import * as React from "react"
import { StaticImage } from "gatsby-plugin-image"
import Button from "../components/Button"

export default function MateriaisEducativosCta() {
  return (
    <div className="pt-6 px-4 px-xl-6 tac mt-4r bg-image-materiais-educativos p-r o-h">
      <div className="p-r z1">
        <h3 className="c-purple h2">Materiais estratégicos</h3>
        <p className="mt-2r">
          A partir da nossa expertise de mais de 14 anos em Diagnóstico e Planejamento de Comunicação Integrada, Gestão de Riscos Reputacionais e Mapeamento de fluxos e processos de comunicação, desenvolvemos diversos materiais estratégicos para sua empresa.
        </p>
        <div className="mt-2r mb-2r">
          <Button to="/materiais-educativos" className="btn bg-color-purple dib">
            	Acesse os conteúdos
          </Button>
        </div>
        <StaticImage
          src="../../images/img-materiais-educativos-cta.png"
          alt="Acompanhe nossos materiais estratégicos"
          className="mb--6"
        />
      </div>
    </div>
  )
}